import 'react-hot-loader';
import 'app/common/publicPath';
import 'app/common/patch';

import 'app/legacy/app';
import 'app/interop';

import 'app/app.scss';

import { get } from 'lodash';

import { configureTracking } from '@zapier/tracking';
import { configureErrorTracking } from 'app/error/tracking';

import buildPlugins from 'app/common/buildPlugins';

import z from 'app/common/z';

import Devtools from 'app/devtools-loader';

import createApp from 'app/common/createApp';
import { SERVICE_NAME } from 'app/common/Config';

configureErrorTracking();

configureTracking({
  service: SERVICE_NAME,
  release: process.env.COMMIT_HASH,
});

Devtools.preCreateApp();

const initialReduxState = JSON.parse(
  get(window, ['INITIAL_REACT_REDUX_STATE'], '{}')
);
const app = createApp({ plugins: buildPlugins(), initialReduxState });

z.app.dangerousGlobalStore = app.store;

Devtools.postCreateApp(app);

// Append the commit version, provided by webpack
window.Z_COMMIT_HASH = process.env.COMMIT_HASH;

app.run();
